<template>
	<el-carousel class="carousel">
		<el-carousel-item v-for="(item, index) in imgList?.slice(0, 5)" :key="index">
			<img class="carousel_img" :src="item" alt="carousel image" />
		</el-carousel-item>
	</el-carousel>

</template>

<script setup lang="ts">
    const props = defineProps({
		imgList: {
			type: Array,
			default: () => []
		}
	})
</script>

<style lang="stylus" scoped>
.carousel{
	width 100%
	height: 0;
		padding-bottom: 33.33%;
	position: relative;
	:deep(.el-carousel__container) {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}
	.carousel_img{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
</style>